// ProgressBar.js

import React from "react";
import { Box, Grid, Grommet, Meter, Stack, Text, defaultProps } from "grommet";

const { size } = defaultProps.theme.global;

const ProgressBar = (props) => {
    const {value, message} = props;    

    const values = [
        {
          value: Math.round(value),
          color: "accent-1"
        },
        {
          value: Math.round(100 - value),
          color: "accent-4"
        }
    ];

    const defaultMessage = message;    
    const [active, setActive] = React.useState();
  
    const onHoverHandler = (over, value) => {
      if (over) {
        setActive(Math.round(value.value));
      } else {
        setActive();
      }
    };
  
    const adjustedValues = values.map(value => {
      const result = { ...value };
      result.onHover = over => onHoverHandler(over, result);
      return result;
    });
  
    return (
      <Grid columns={{ count: "fit", size: ["auto", "small"] }} gap="medium">
      <Box>
        {/* <Text alignSelf="center" weight="bold">Progress</Text> */}
        <Box alignSelf="center" height="xsmall" width="xsmall">
          <Stack anchor="center" fill guidingChild="first">
            <Box fill>
              <Meter
                thickness="xlarge"
                type="circle"
                values={adjustedValues}
                aria-label="multiple value meter"
              />
            </Box>
            <Box pad="small">
              {active ? (
                <Box>
                  <Text  weight="bold">{active.value}%</Text>
                </Box>
              ) : (
                <Box>
                  <Text  weight="bold">{defaultMessage}</Text>
                </Box>
              )}
            </Box>
          </Stack>
        </Box>
      </Box>
      </Grid>
    );
  };

  export default ProgressBar;